import { mapGetters } from "vuex";
import { validationMixin } from 'vuelidate'
import { required, maxLength, minLength, email} from 'vuelidate/lib/validators' 

export default {
  mixins: [validationMixin],
  validations: {
    select:{
      delo:{ required },
      adress: { required },
      uchastok: { required },
      sudia: { required },
      isTrue2: {
        checked (val) {
          return val
        },
      },
      phone: { required },
      dt: { required },
      fio: { required },
      email: { required, email },
      emailSud: { required, email },
  }},
  data: () => ({
    // checkbox : false,
    file: null,
    isLoadDoc: false,
    amount: 1500,
    job_id: null,
    menu2: false,
    isLoad: false,
    pay_form: null,
    step: 1,
    pdfBlobURL: null,
    settings: {
			priceСancellation: null,
		},
    loading: {
      uchastok: false,
      emailSud: false
    },
    judges: [],
    typeSud:[
      {
        name: 'Мировой Судья',
        id: 1
      },
      {
        name: 'Арбитражный Судья',
        id: 2
      },
    ],
    select:{
      adress: null,
      uchastok: null,
      sudia: null,
      delo: null,
      dt: null,
      phone: null,
      fio: null,
      email: null,
      emailSud: null,
      isTrue: false,
      isTrue2: false,
      isTrue3: true,
      uuid: null
    },  
    photo: '/static/img/photoDoc1.svg',
    photo2: '/static/img/photoDoc2.svg',
  }),
  watch: {
    uchastok(val) {
      this.findJudges(val, 'adress')
    },
    emailSud(val) {
      this.findJudges(val, 'email')
    },
    step(to, from) {
      if (to == 5){
        setTimeout(()=>{
            this.step = 1;
        },7000);
      }
    }
  },
  mounted () {
    this.step = 1;

    this.$axios.get(`order/tariff`).then(({data}) => {
			this.settings.priceСancellation = data.result.find(item => item.key == 'cancellation').meta.cost
    })

    this.$root.$on('socket.ocr.text', (item) => {
      if(item){
        let text = JSON.parse(item);
        if(text.id[0] != this.job_id){
          return;
        }
        if(text.error){
          notify.error('Документ не распознан или неверный. Пожалуйста, введите данные вручную или загрузите другое изображение.');
          this.isLoad = false;
          this.step = 2;
          return;
        }
        this.select = text;
        this.isLoad = false;
        this.step = 2;
      }
    });
  },
  methods: {
    dowloadPdf(){
      this.$fileSeaver.saveAs(this.pdfBlobURL);
      // const label = 'pdfFile';
      // const blob = this.pdfBlobURL;
      // const link = document.createElement('a')
      //   link.href = URL.createObjectURL(this.pdfBlobURL)
      //   link.download = this.pdfBlobURL;
      //   link.click()
      //   URL.revokeObjectURL(link.href)
      window.open(this.pdfBlobURL);
    },
    toTop(){
      this.$root.$emit('all.scroll')
      $('#app-content').scrollTop(0);
      $('#app-content_mobile').scrollTop(0);
    },
    findJudges(v, trigger) {
      if(v.length > 3) {
        if(trigger == 'adress') this.loading.uchastok = true
        if(trigger == 'email') this.loading.emailSud = true
  
        this.$axios.post('ocr/judges', {
          find: v
        }).then(({data}) => {
          this.judges = data.result
        }).finally(() => {
          this.$nextTick(() => {
            if(trigger == 'adress') this.loading.uchastok = false
            if(trigger == 'email') this.loading.emailSud = false
            this.$nextTick(() => {
              this.$nextTick(() => {
                this.$refs.adresslist.maxWidth = this.$refs.rowuchastok.clientWidth
              })
            })
          })
        })
      } else {
        this.judges = []
      }
    },
    selectJudges(val) {
      this.select.uchastok = val.adress
      this.select.emailSud = val.email
      if(val.type == 'world') {
        this.select.sudia = 1
      } else {
        this.select.sudia = 2
      }
    },
    emailSudErrors () {
      const errors = []
      if (!this. $v.select.emailSud.$dirty) return errors
      !this. $v.select.emailSud.email && errors.push('Неккоректный e-mail')
      !this. $v.select.emailSud.required && errors.push('Обязательное поле')
      return errors
    },
    emailErrors () {
      const errors = []
      if (!this. $v.select.email.$dirty) return errors
      !this. $v.select.email.email && errors.push('Неккоректный e-mail');
      !this. $v.select.email.required && errors.push('Обязательное поле');
      return errors
    },
    fioErrors () {
      const errors = []
      if (!this.$v.select.fio.$dirty) return errors
      // !this. $v.select.fio.required && errors.push('Обязательное поле')
      let redex = /[А-Яа-я]{3,}.[А-Яа-я]{3,}.[А-Яа-я]{3,}/;
      let con  = redex.exec(this.select.fio);
      if (!con){
        errors.push('Формат ФИО - Иванов Иван Иванович')
      } 
      !this. $v.select.fio.required && errors.push('Обязательное поле')
      return errors
    },
    deloErrors () {
      const errors = []
      if (!this.$v.select.delo.$dirty) return errors
      !this. $v.select.delo.required && errors.push('Обязательное поле')
      return errors
    },
    phoneErrors() {
      const errors = []
      if (!this.$v.select.phone.$dirty) return errors
      !this. $v.select.phone.required && errors.push('Обязательное поле')
      return errors
    },
    dtErrors () {
      const errors = []
      if (!this.$v.select.dt.$dirty) return errors
      !this. $v.select.dt.required && errors.push('Обязательное поле')
      return errors
    },
    adressErrors () {
      const errors = []
      if (!this.$v.select.adress.$dirty) return errors
      !this. $v.select.adress.required && errors.push('Обязательное поле')
      return errors
    },
    uchastokErrors () {
      const errors = []
      if (!this.$v.select.uchastok.$dirty) return errors
      !this. $v.select.uchastok.required && errors.push('Обязательное поле')
      return errors
    },
    sudiaErrors () {
      const errors = []
      if (!this.$v.select.sudia.$dirty) return errors
      !this. $v.select.sudia.required && errors.push('Обязательное поле')
      return errors
    },
    isTrue2Errors () {
      const errors = []
      if (!this.$v.select.isTrue2.$dirty) return errors
      !this.$v.select.isTrue2.checked && errors.push('Обязательное поле')
      return errors
    },
    reg(){
      this.$root.$emit('modal.reg');
    },
    send(){
      this.$v.select.$touch();
      if(this.$v.select.$invalid){
        return;
      } 
      let redex = /[А-Яа-я]{3,}.[А-Яа-я]{3,}.[А-Яа-я]{3,}/;
      let con  = redex.exec(this.select.fio);
      if (!con){
        return;
      }
      this.select.phone = this.select.phone.replace(/[^\w\s]/gi, '');
      let dt = new Date().getTime();
      this.select.uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          let r = (dt + Math.random()*16)%16 | 0;
          dt = Math.floor(dt/16);
          return (c=='x' ? r :(r&0x3|0x8)).toString(16);
      });

      this.isLoadDoc = true;
      this.$axios.post('ocr/pdfexport', {
        ...this.select
      } ,{ responseType: 'blob' }).then(response => {
        this.pdfBlobURL = window.URL.createObjectURL(response.data)
      }).catch(() => {
      }).finally(() => {
        this.step = 3;
        this.isLoadDoc = false;
      })
    },
    toPay(){
      this.step = 4;
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.$axios.get(`yookassa/order/${this.select.uuid}/payment`).then(({data}) => {
            //Инициализация виджета. Все параметры обязательные.
            const checkout = new window.YooMoneyCheckoutWidget({
              confirmation_token: data.result.token,
              return_url: `${this.getApi}yookassa/order/${this.select.uuid}/checkout`,
              error_callback: function(error) {
                  console.log(error)
              }
            });
    
            //Отображение платежной формы в контейнере
            checkout.render('payment-form')
            this.isLoad = false
            
          })
        });
      });

    },
    sendTest(){
      this.$axios.post('ocr/send', this.select).then(res => {
      }).catch(() => {
      }).finally(() => {
      })
    },
    nextStep(step){
      this.step = step;
      this.toTop();
    },
    lastStep(step){
      this.job_id = null;
      // this.step = step;
      this.step = 1;
      this.file = null;
      this.select = {
        adress: null,
        uchastok: null,
        sudia: null,
        delo: null,
        phone: null,
        // body: null,
        dt: null,
        fio: null,
        email: null,
        emailSud: null,
        isTrue: false
      };
      this.$v.$reset()
    },
    toCancel(){
      if (this.$route.hash) this.$router.push('/cancel')
      this.$router.push('/cancel/#info')
    },
    fileChange(e) {
      this.isLoad = true;
      setTimeout(() => {
        notify.error('Документ не распознан или неверный. Пожалуйста, введите данные вручную или загрузите другое изображение.');
        this.isLoad = false;
        this.step = 2;
      }, 60000);
      this.$root.$emit('all.scroll')
      $('#app-content').scrollTop(0);
      $('#app-content_mobile').scrollTop(0);

      var files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;
      this.file = files[0];

      let formData = new FormData();
      formData.append('file', files[0]);

      this.$axios.post('ocr/transform', 
        formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        if(res){
          this.job_id = res.data.result.job_id[0];
        }
      }).finally(() => {
        this.$nextTick(() => {
          this.$root.$emit('all.scroll')
          $('#app-content').scrollTop(0);
          $('#app-content_mobile').scrollTop(0);
        }); 
      });
    },
  },
  computed: {
    ...mapGetters(['getApi']),
    uchastok() {
      return this.select.uchastok
    },
    emailSud() {
      return this.select.emailSud
    }
  },
}



// WEBPACK FOOTER //
// ./src/pages/Cancel/cancel.js